<template>
    <b-modal id="modal-sukses" title="Sukses" centered
        no-close-on-backdrop no-close-on-esc hide-header-close
        ok-only ok-title="OK" @ok="$emit('done')" auto-focus-button="ok"
    >
        Pembayaran telah sukses dilakukan. Silahkan melanjutkan proses ke kasir.
        <br /><br />
        No. Kwitansi:
        <h3 class="font-weight-bold text-primary">{{ noKwitansi }}</h3>
        <b-alert v-if="isRollover" variant="info" show class="mt-3 mb-0">
            <i class="fa fa-info-circle mr-1"></i>
            <strong>Informasi Rollover:</strong><br/>
            Setelah kasir mencetak kwitansi, sistem akan otomatis menerbitkan <strong>Surat Bukti Gadai (SBG) Baru</strong>.
        </b-alert>
    </b-modal>
</template>

<script>
export default {
    name: 'modal-sukses',
    props: {
        noKwitansi: { type: String, required: true },
        isRollover: { type: Boolean, default: false }
    }
}
</script>